import { FirebaseDataService } from "../../../../services/firebase-data.service";

const firebaseDataService = new FirebaseDataService();

export function fetchGraphSocialCounts(statsObj, user, graph) {
    return new Promise(async (resolve, reject) => {
    try {
        // firebaseDataService.graphSocialCounts(statsObj, "socialCounts").subscribe((data) => {
        firebaseDataService.getStats(statsObj,user,graph, "socialCounts").subscribe((data) => {
        resolve({ data });
      });
    } catch (error) {
      reject(error);
    }
  });
}